import React from 'react';

import { Layout } from '@components/Layout';
import { ContactAddForm } from '@components/utilities/Contact/ContactAddForm';
import { Container } from '@components/utilities/Contact/Container';
import { VerticalSpace } from '@components/VerticalSpace';
import { bookingInquiryStrings } from '@data/bookingInquiry';
import { ContactType } from '@models/Contact';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import clsx from 'clsx';

const strings = createStrings({
  ja: {
    title: (contactType: ContactType) => `${bookingInquiryStrings[contactType]}情報の新規登録`,
    addContact: '新規登録',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  body: {
    ...common.flexColumn,
    flex: 1,
  },
  contactContainer: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    columnGap: 40,
  },
}));

export interface AddContactProps {
  contactType: ContactType;
  ownedContactType: ContactType;
}

export const AddContact: React.FC<AddContactProps> = (props) => {
  const { contactType, ownedContactType } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <Layout
      title={strings.title(contactType)}
      breadcrumbs={[
        '/utilities/Dashboard',
        contactType === 'shipper'
          ? '/utilities/Contact/Shippers/Shippers'
          : '/utilities/Contact/Consignees/Consignees',
        { text: strings.addContact },
      ]}
    >
      <div className={classes.body}>
        <Container>
          <VerticalSpace height={16} />

          <div className={clsx(classes.pageTitleText, classes.textPrimary)}>
            {strings.title(contactType)}
          </div>

          <VerticalSpace height={16} />
          <div className={classes.contactContainer}>
            <ContactAddForm contactType={contactType} ownedContactType={ownedContactType} />
          </div>

          <VerticalSpace height={100} />
        </Container>
      </div>
    </Layout>
  );
};
